import { render, staticRenderFns } from "./UserEditDialog.vue?vue&type=template&id=203dd846&scoped=true&"
import script from "./UserEditDialog.vue?vue&type=script&lang=js&"
export * from "./UserEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203dd846",
  null
  
)

export default component.exports